import React, {useState} from "react";
import "./ToNext.css";
import axios from "axios";
import LayoutInvest from "../Layout/LayoutInvest";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";

function isNumber(n) { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); }

function InvestToNextSource (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}
    const [VisibleSendQuestion, setVisibleSendQuestion] = useState('SendQuestionNo');
    const [NumberValue, setNumberValue] = useState('');
    const [TextValue, setTextValue] = useState('');
    const [eMailError, setEMailError] = useState('');
    const [TextError, setTextError] = useState('');
    const [NumberErrorVisible, setNumberErrorVisible] = useState('isNoVisible');
    const [TextErrorVisible, setTextErrorVisible] = useState('isNoVisible');
    const [SendQuestionMainBottomMainInVisible, setSendQuestionMainBottomMainInVisible] = useState('isNoVisible');
    const [SendQuestionMainBottomSuccessVisible, setSendQuestionMainBottomSuccessVisible] = useState('isNoVisible');


    function handleMailChange(event) {
            setNumberValue(event.target.value);
            if (isNumber(NumberValue))  {setNumberErrorVisible("isNoVisible");
                event.preventDefault();
            }
        }

    function ChangeSendQuestionVisible(VisibleSendQuestion) {
            setVisibleSendQuestion(VisibleSendQuestion);     }



    function handleTexthange(event) {
            setTextValue(event.target.value);
            if (TextValue !== '') {setTextErrorVisible("isNoVisible");}
        }

    async function handleSubmit (e) {
            //console.log('ertwt');
            if(!isNumber(NumberValue+'nnnn'))  {
                setNumberErrorVisible("isVisible");
                // e.preventDefault();
            }
            else {
                setNumberErrorVisible("isNoVisible");
            }
            if(TextValue === '')  {
                setTextErrorVisible("isVisible");
            }
            if (isNumber(NumberValue) && (TextValue !== '')) {
                //console.log('NumberValue', NumberValue);
                //console.log('TextValue', TextValue);
                // e.preventDefault();
                let SubjectMail = 'Invest Next Stage';
                let output = NumberValue;

                let data = {
                    SubjectMail,
                    output
                };
                //console.log('data', data);
                // console.log('SubjectMail',SubjectMail);
                // console.log('output',output);
                axios
                    .post('https://myadmin.fxbitcoin.org/send', data)
                    .then(() => {
                            //console.log('Mail Created');
                            setSendQuestionMainBottomMainInVisible("isNoVisible");
                            setSendQuestionMainBottomSuccessVisible('isVisible');
                        }
                    )
                    .catch(e => console.log(e));
            }
        };

    return (
        <LayoutInvest lang={props.lang}>
            <div  className="InvestNextStep">
                <div  className="InvestNextStepIn">
                    <div  className="InvestNextStepMain">
                        <div  className="InvestRegistrationGridRegistrationTitle"><TextSource ArrIndex= 'InvestToNext0015'>TRANSFER TO THE NEXT STAGE</TextSource> </div>
                        <div  className="InvestRegistrationGridRegistrationText"><TextSource ArrIndex= 'InvestToNext0020'>We are glad that you have earned money. According to the terms of the contract, we receive 50% of earnings. Please fill in these fields.</TextSource> </div>
                            <form  onSubmit={handleSubmit}>
                                <div  className="InvestRegistrationGridRegistrationTextSmall"><TextSource ArrIndex= 'InvestToNext0025'>Номер инвест счета</TextSource> </div>
                                <input type="text" placeholder='' name="NumberValue" value={NumberValue} onChange={handleMailChange} />
                            <div className={'SendQuestionMainBottomError '+ NumberErrorVisible} ><TextSource ArrIndex= 'InvestToNext0030'>Problem with Client Number</TextSource> </div>
                                <div  className="InvestRegistrationGridRegistrationTextSmall"><TextSource ArrIndex= 'InvestToNext0035'>Ваш пароль</TextSource> </div>
                                <input type="password" name="TextValue" placeholder='' value={TextValue} onChange={handleTexthange} />
                                <div className={'SendQuestionMainBottomError '+ TextErrorVisible}><TextSource ArrIndex= 'InvestToNext0040'>Problems with authorization</TextSource> </div>
                                <div className="StandartButtonOut CompanyContactPlace03">
                                    <div   onClick={() => handleSubmit()} className='ButtonInvest'><TextSource ArrIndex= 'InvestToNext0045'>Переход на следующий этап</TextSource>  </div>
                                </div>
                            </form>
                            {/*<div  className="InvestRegistrationGridRegistrationTextMail">support@Fxbitcoin.trade</div>*/}
                        </div>

                </div>
            </div>
        </LayoutInvest>
    )}

export default InvestToNextSource